<template>

<com-item name="game.timeline" :size="size" :loading="loading" :is-empty="!active" :any-height="true" :no-border="true" :no-hover="true">

	<template v-slot:stats>

		<div class="timeline" v-if="active">

			<div class="timeline-filters">

				<div class="timeline-filter" v-for="f in filters" :key="f.type" :class="{ 'is-active': isFilterActive(f.type), ['is-' + f.type]: true }" v-on:click="toggleFilter(f.type)" v-tooltip="isFilterActive(f.type) ? 'Click to show all' : 'Click to filter by ' + f.label.toLowerCase()">

					{{ f.label }} <span v-if="f.count">({{ f.count }})</span>

				</div>

			</div>

			<div class="timeline-year" v-for="(year, yIndex) in groupedEvents" :key="yIndex">

				<div class="timeline-year-head">

					<div class="timeline-year-label">{{ year.year }}</div>

					<div class="timeline-year-count">{{ year.events.length }} event{{ year.events.length === 1 ? '' : 's' }}</div>

				</div>

				<div class="timeline-cards">

					<div class="timeline-card" v-for="(event, eIndex) in year.events" :key="eIndex" :class="['is-' + event.type, { 'is-linked': event.link }]" v-on:click="onCardClick(event)" v-tooltip="event.link ? 'Click to view' : false">

						<div class="timeline-card-accent" :class="'is-' + event.type" />

						<div class="timeline-card-icon" :class="'is-' + event.type"><i :class="'fa fa-' + event.icon" /></div>

						<div class="timeline-card-body">

							<div class="timeline-card-label">{{ event.label }}</div>

							<div class="timeline-card-detail" v-if="event.detail">{{ event.detail }}</div>

						</div>

						<div class="timeline-card-date">{{ event.day }} {{ event.month }}</div>

					</div>

				</div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			activeFilters: []
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/game/timeline']

		},

		allEvents: function() {

			return (this.data && this.data.events) ? this.data.events : []

		},

		events: function() {

			if (!this.activeFilters.length) return this.allEvents

			var filters = this.activeFilters

			return this.allEvents.filter(function(e) { return filters.indexOf(e.type) !== -1 })

		},

		active: function() {

			return this.allEvents.length && !this.loading

		},

		filters: function() {

			var counts = {}

			this.allEvents.forEach(function(e) {

				if (!counts[e.type]) counts[e.type] = 0
				counts[e.type]++

			})

			var defs = [
				{ type: 'play', label: 'Plays', icon: 'dice' },
				{ type: 'win', label: 'Wins', icon: 'trophy' },
				{ type: 'opponent', label: 'Opponents', icon: 'users' },
				{ type: 'collection', label: 'Collection', icon: 'plus' },
				{ type: 'streak', label: 'Streaks', icon: 'pause' },
				{ type: 'rating', label: 'Ratings', icon: 'star' },
				{ type: 'location', label: 'Locations', icon: 'map-marker-alt' },
				{ type: 'score', label: 'Scores', icon: 'star' }
			]

			return defs.filter(function(d) { return counts[d.type] }).map(function(d) {

				d.count = counts[d.type]
				return d

			})

		},

		groupedEvents: function() {

			if (!this.events.length) return []

			var months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			var groups = []
			var currentYear = null
			var currentGroup = null

			for (var i = 0; i < this.events.length; i++) {

				var event = this.events[i]
				var date = new Date(event.date * 1000)
				var year = date.getFullYear().toString()
				var day = date.getDate().toString()
				var month = months[date.getMonth() + 1]

				if (year !== currentYear) {

					currentYear = year
					currentGroup = { year: year, events: [] }
					groups.push(currentGroup)

				}

				currentGroup.events.push({
					type: event.type,
					label: event.label,
					detail: event.detail,
					icon: event.icon,
					day: day,
					month: month,
					link: this.buildLink(event)
				})

			}

			groups.reverse()

			// On mobile, reverse events within each year so newest are first
			if (this.$isMobile) {

				for (var g = 0; g < groups.length; g++) {

					groups[g].events.reverse()

				}

			}

			return groups

		}

	},

	methods: {

		isFilterActive: function(type) {

			return this.activeFilters.indexOf(type) !== -1

		},

		toggleFilter: function(type) {

			var index = this.activeFilters.indexOf(type)

			if (index !== -1) {

				this.activeFilters.splice(index, 1)

			} else {

				this.activeFilters.push(type)

			}

		},

		buildLink: function(event) {

			if (event.playId) {

				return { name: 'Plays', query: { 'play.subset': String(event.playId) } }

			}

			if (event.opponentSlug) {

				return { name: 'InsightsPlayer', params: { player: event.opponentSlug } }

			}

			if (event.type === 'rating' || event.type === 'collection') {

				return { name: 'Ratings', query: { 'query': String(this.$route.params.game) } }

			}

			return null

		},

		onCardClick: function(event) {

			if (event.link) {

				this.$routerPush(event.link).catch(function() {})

			}

		}

	}

}

</script>

<style scoped>

.timeline {
	width: 100%;
}

/* Filters */

.timeline-filters {
	display: flex;
	gap: 6px;
	margin-bottom: 12px;
}

.timeline-filter {
	flex: 1;
	font-size: 12px;
	font-weight: 500;
	height: 32px;
	line-height: 32px;
	text-align: center;
	border-radius: 4px;
	cursor: pointer;
	user-select: none;
	border: 1px solid #e8e8e8;
	color: #999;
	background-color: #fff;
	transition: all 0.15s;
}

.timeline-filter span {
	font-weight: 400;
	font-size: 11px;
}

.is-desktop .timeline-filter:hover {
	border-color: #ccc;
	color: #666;
}

.timeline-filter.is-active.is-play { background-color: rgba(47, 196, 130, 0.12); border-color: #2FC482; color: #1a9960; }
.timeline-filter.is-active.is-win { background-color: rgba(245, 166, 35, 0.12); border-color: #f5a623; color: #c88510; }
.timeline-filter.is-active.is-opponent { background-color: rgba(26, 188, 156, 0.12); border-color: #1abc9c; color: #148f77; }
.timeline-filter.is-active.is-collection { background-color: rgba(72, 129, 187, 0.12); border-color: #4881bb; color: #3a6a9a; }
.timeline-filter.is-active.is-streak { background-color: rgba(232, 93, 117, 0.12); border-color: #e85d75; color: #c0392b; }
.timeline-filter.is-active.is-rating { background-color: rgba(245, 166, 35, 0.12); border-color: #f5a623; color: #c88510; }
.timeline-filter.is-active.is-location { background-color: rgba(155, 89, 182, 0.12); border-color: #9b59b6; color: #7d3c98; }
.timeline-filter.is-active.is-score { background-color: rgba(245, 166, 35, 0.12); border-color: #f5a623; color: #c88510; }

/* Year section */

.timeline-year {
	margin-bottom: 8px;
}

.timeline-year:last-child {
	margin-bottom: 0;
}

.timeline-year-head {
	display: flex;
	align-items: baseline;
	gap: 8px;
	padding: 8px 0 6px;
}

.timeline-year-label {
	font-size: 18px;
	font-weight: 700;
	color: #333;
}

.timeline-year-count {
	font-size: 13px;
	font-weight: 400;
	color: #999;
}

/* Card grid */

.timeline-cards {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 8px;
}

.is-mobile .timeline-cards {
	grid-template-columns: 1fr;
}

.is-mobile .timeline-filters {
	display: none;
}

/* Individual card */

.timeline-card {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 10px;
	padding: 12px;
	border: 1px solid #eee;
	border-radius: 6px;
	background-color: #fff;
	overflow: hidden;
}

.timeline-card.is-linked {
	cursor: pointer;
}

.is-desktop .timeline-card.is-linked:hover {
	border-color: #ddd;
	background-color: #f8fbfd;
}

/* Left accent bar */

.timeline-card-accent {
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	width: 3px;
	border-radius: 6px 0 0 6px;
}

.timeline-card-accent.is-play { background-color: #2FC482; }
.timeline-card-accent.is-win { background-color: #f5a623; }
.timeline-card-accent.is-collection { background-color: #4881bb; }
.timeline-card-accent.is-streak { background-color: #e85d75; }
.timeline-card-accent.is-rating { background-color: #f5a623; }
.timeline-card-accent.is-location { background-color: #9b59b6; }
.timeline-card-accent.is-opponent { background-color: #1abc9c; }
.timeline-card-accent.is-score { background-color: #f5a623; }

/* Icon */

.timeline-card-icon {
	width: 28px;
	height: 28px;
	min-width: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	flex-shrink: 0;
}

.timeline-card-icon.is-play { background-color: rgba(47, 196, 130, 0.12); color: #2FC482; }
.timeline-card-icon.is-win { background-color: rgba(245, 166, 35, 0.12); color: #f5a623; }
.timeline-card-icon.is-collection { background-color: rgba(72, 129, 187, 0.12); color: #4881bb; }
.timeline-card-icon.is-streak { background-color: rgba(232, 93, 117, 0.12); color: #e85d75; }
.timeline-card-icon.is-rating { background-color: rgba(245, 166, 35, 0.12); color: #f5a623; }
.timeline-card-icon.is-location { background-color: rgba(155, 89, 182, 0.12); color: #9b59b6; }
.timeline-card-icon.is-opponent { background-color: rgba(26, 188, 156, 0.12); color: #1abc9c; }
.timeline-card-icon.is-score { background-color: rgba(245, 166, 35, 0.12); color: #f5a623; }

/* Body */

.timeline-card-body {
	flex-grow: 1;
	min-width: 0;
}

.timeline-card-label {
	font-size: 14px;
	font-weight: 600;
	color: #333;
	line-height: 16px;
}

.timeline-card-detail {
	font-size: 12px;
	font-weight: 400;
	color: #666;
	margin-top: 1px;
	line-height: 1.2;
}

/* Date */

.timeline-card-date {
	font-size: 12px;
	font-weight: 500;
	color: #999;
	white-space: nowrap;
	flex-shrink: 0;
	padding-top: 1px;
}

</style>
